import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { UserService } from '../../../services/user.service';
import { AuthService } from '../../../services/auth.service';
import * as userActions from './user.action';

@Injectable()
export class UserEffects {
  loadUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userActions.loadUsers),
      switchMap(() =>
        this.userService.getUsers().pipe(
          map((users) => userActions.loadUsersSuccess({ users })),
          catchError((error) => of(userActions.loadUsersFailure({ error })))
        )
      )
    )
  );

  saveUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userActions.saveUser),
      switchMap((action) =>
        this.userService.saveUserAndNotifications(action.user).pipe(
          map((user) => userActions.saveUserSuccess({ user })),
          catchError((error) => of(userActions.saveUserFailure({ error })))
        )
      )
    )
  );
  forgotPasswordByUserId = createEffect(() =>
    this.actions$.pipe(
      ofType(userActions.forgotPasswordByUserId),
      switchMap((action) =>
        this.authService.forgotPasswordByUserId(action.userId).pipe(
          map((response) => userActions.forgotPasswordByUserIdSuccess({ success: response.ok })),
          catchError((error) => of(userActions.saveUserFailure({ error })))
        )
      )
    )
  );

  getUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userActions.getUser),
      mergeMap((action) =>
        this.userService.getUser(action.userId).pipe(
          map((user) => userActions.getUserSuccess({ user })),
          catchError((error) => of(userActions.getUserFailure({ error })))
        )
      )
    )
  );
  constructor(private actions$: Actions, private userService: UserService, private authService: AuthService) { }
}
